// Fix ts error: Property 'dataLayer' does not exist on type 'Window & typeof globalThis'.
declare const window: Window & {
  dataLayer: {
    push: (data: Record<string, unknown>) => void;
  };
};

// Push data to the GTM data layer.
const gtmDataLayerPush = (data: {
  [key: string]:
    | string
    | number
    | Array<{ [key: string]: string | number | null | undefined }>
    | null
    | undefined
    | object;
}) => {
  window.dataLayer?.push(data);
};

// Clear the previous ecommerce object.
const clearEcommerceObject = () => {
  gtmDataLayerPush({ ecommerce: null });
};

export { gtmDataLayerPush, clearEcommerceObject };
